module.exports = __webpack_public_path__ + "components/breakheader/static/icon--heart-ba9b32649980e80e3abb2f12f13ad503.svg";